import _ from 'lodash'
import RepeatByHeaderCell from './repeat-by-header-cell'
import reportConstants from 'scoreboard/reports/report-constants'

/**
 * Represents a cell within a bottom level breakdown
 */
class BottomRepeatByHeaderCell extends RepeatByHeaderCell {

	constructor(stack, columnAttrsOrBreakdownData, repeatByAttributes, opts = {}) {
		super(stack, columnAttrsOrBreakdownData, repeatByAttributes, opts)
		this.position = reportConstants.REPEAT_BY_BOTTOM_POSITION
	}

	rowIndex() {
		return this.tableStack._rows.length-1
	}

	sideDomNodes() {
		return [...this.domNodes(), ...this._stackBodyDomNodes]
	}

	isSameLevel(cell) {
		return this.isSameRepeatBy(cell) && cell instanceof BottomRepeatByHeaderCell
	}

	columnStyle() {
		if (!this.inBreakdownRow()) {
			return super.columnStyle()
		}
		return this._columnHeaderCell().columnStyle()
	}

	_columnHeaderCell() {
		let columnHeaderCell = this
		while (columnHeaderCell.inBreakdownRow()) {
			//in a repeat by, only the column row has the style information
			// so recurse up until we find the non-breakdown row
			columnHeaderCell = columnHeaderCell.options.parentCell
		}
		return columnHeaderCell
	}

	_sortDirection(columnModel, reportModel) {
		//show the icon if the column is being sorted and the breakdown sort value
		//matches or is sorting by all values
		if (!this.sortable || !columnModel.isSorting(reportModel)) {
			return null
		}

		//get the period order index this header is under
		let cell = this
		let breakdownDataByIndex = {}
		while (cell != null) {
			if (cell.inBreakdownRow()) {
				breakdownDataByIndex[cell.options.breakdownReference.breakdownIndex] = {
					columnAttributes: cell._columnAttributes,
					columnIndex: cell.orderIndex
				}
			}
			cell = cell.options.parentCell
		}

		//show the icon if the column is sort AND we're sorting by every value
		//or the column falls under the breakdown value we're sorting on
		let isSortingThisValue = _.every(this.stack.breakdowns(), (breakdown, breakdownIndex) => {
			let breakdownValue = breakdown.get('sortByValue')
			//if no value we're sorting on every column, so show indicator
			if (_.isNil(breakdownValue)) {
				return true
			}
			let breakdownColumnIndex = breakdown.get('sortByColumnIndex')
			let relative = !!breakdown.get('relative')
			let {columnIndex, columnAttributes} = breakdownDataByIndex[breakdownIndex]
			return relative ? columnIndex == breakdownColumnIndex
				// #54221 the sortByValue has to be escaped correctly for the
				// select, so do the same for the column id here
				: columnAttributes.id?.replace(/"/g, '\\"') == breakdownValue
		})

		return isSortingThisValue ? columnModel.columnSortType(reportModel) : null
	}

}

export default BottomRepeatByHeaderCell
BottomRepeatByHeaderCell.__filename__ = 'reports/common/table/bottom-repeat-by-header-cell.js'
